import SidePanelLayout from "aldoo-ra/SidePanel"
import FeatureMatrixEditor from "./FeatureMatrixEditor"

export default function FeatureMatrix() {
  return (
    <SidePanelLayout
      menuName="AdminFeatureMatrix"
      tabs={{
        "feature-matrix": FeatureMatrixEditor,
      }}
    />
  )
}
